import Controls from '@stories/Components/Misc/Carousels/Carousel/Controls/Controls';
import Dots from '@stories/Components/Misc/Carousels/Carousel/Dots/Dots';
import * as React from 'react';
import { useCarouselContext } from '../CarouselProvider/CarouselProvider';
import S from './Pagination.styles';
const Pagination = React.forwardRef((props, ref) => {
    const carousel = useCarouselContext();
    if (carousel.maxIndex === 0) {
        return null;
    }
    return (React.createElement(S.Container, { ref: ref },
        React.createElement(Dots, { itemCount: carousel.maxIndex + 1, activeIndex: carousel.activeIndex }),
        React.createElement(Controls, { ...props })));
});
Pagination.displayName = 'CarouselPagination';
export default Pagination;
